module.exports = __webpack_public_path__ + "static/media/29.ec7db331.jpg";